import { render, staticRenderFns } from "./LmDocumentWorkflow.vue?vue&type=template&id=ca7d0d8c&scoped=true"
import script from "./LmDocumentWorkflow.vue?vue&type=script&lang=js"
export * from "./LmDocumentWorkflow.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentWorkflow.vue?vue&type=style&index=0&id=ca7d0d8c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d0d8c",
  null
  
)

export default component.exports